import React from "react";
import { NotificationDTO } from "../../../models/dtos/profile/NotificationDTO";
import NotificationTypes from "../../../models/interfaces/profile/NotificationTypes";
import Notification from "../../shared/notification/Notification";
import axios from "axios";

export default class CheckVersionComponent extends React.PureComponent<
  {},
  { version: string; notification: NotificationDTO; showNotify: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      version: "",
      showNotify: false,
      notification: {
        description: "",
        Theme: NotificationTypes.Successfully,
        title: "",
      },
    };
  }

  getVersion() {
    let self = this;

    axios({
      method: "get",
      url: "version.json",
      baseURL: "/",
    }).then(function (response: any) {
      self.setState({ version: response.data.version });
      const local_version = localStorage.getItem("version");
      if (!local_version) {
        localStorage.setItem("version", response.data.version);
        window.location.reload();
      } else if (response.data.version != local_version) {
        localStorage.setItem("version", response.data.version);
        window.location.reload();
      }
    });
  }

  showNotify(version: string) {
    this.setState({
      showNotify: true,
      version: version,
      notification: {
        title: "به روز رسانی",
        Theme: NotificationTypes.Successfully,
        description:
          "نسخه‌ی  " +
          version +
          "   اپلیکیشن منتشرشد، برای نصب صفحه‌ی خود را مجدد بارگزاری کنید.",
      },
    });
  }

  close() {}

  checkVersion() {
    let self = this;

    setInterval(() => {
      axios({
        method: "get",
        url: "version.json",
        baseURL: "/",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }).then((response) => {
        if (response.data.version !== self.state.version) {
          this.showNotify(response.data.version);
        }
      });
    }, 40000);
  }

  componentDidMount() {
    let self = this;

    self.getVersion();
    self.checkVersion();
  }

  render() {
    return (
      <>
        {" "}
        {this.state.showNotify ? (
          <Notification
            notification={this.state.notification}
            close={this.close}
            isVisibleFooter={false}
          />
        ) : (
          <></>
        )}
      </>
    );
  }
}
